<template>
  <div class="dialog_box" />
</template>

<script>
import QQAuth from '@/plugins/auth/qqAuth.js'

import {
  ClientCloseSelf, ClientSetUserInfo, ClientCloseTable, ClientGetDBUserInfo,
  ClientSendMsgToTable
} from '@/api/clientApi.js'
import { TableKey, loginAppType, isDevOrTest } from '@/common/const.js'
import { CacheSessionGetSource, CacheSessionGetState, CacheGetLoginType } from '@/common/cache.js'
import api from '@/api'
import keniuApi from '@/api/keniuApi.js'
import { reportServerId } from '@/common/business.js'
import { RetCode } from '@/api/bussinessCode.js'
import { parseURL } from '@/common/utils.js'

const proxyUrl = `${isDevOrTest ? 'http' : 'https'}://pptpluginppt.keniu.com/vip_login_proxy.html`

export default {
  name: 'QQLoginDialog',

  data () {
    return {
      loginType: loginAppType.keniu
    }
  },

  computed: {
    dialogPayAbTestType () { // 支付窗abTest类型
      return this.$store.state.dialogPayAbTestType
    }
  },

  mounted () {
    this.loginType = CacheGetLoginType()
    const url = parseURL(location.href)
    if (url.params?.code) {
      this.checkUrlParams(url.params)
    } else {
      this.loginQQ()
    }
  },

  methods: {
    loginQQ () {
      window.open(new QQAuth({}, this.loginType).openAuthPage())
    },

    checkUrlParams (urlParams) {
      const searchState = urlParams.state
      const qqState = CacheSessionGetState()

      if (!searchState || searchState !== qqState) { return }
      this.userLogin(urlParams.code) // LoginType第三方接口传过去的参数
    },

    userLogin (code) {
      try {
        if (this.loginType === loginAppType.wanmei) {
          this.userLoginWanmei(code)
        } else {
          this.userLoginKenqiu(code)
        }
      } catch {
        this.$toast({
          desc: '登录异常，请联系客服或关闭重试', fn: () => {
            ClientCloseSelf()
          }
        })
      }
    },

    userLoginWanmei (code) {
      const params = { login_type: 2, code, login_app: 'chestnutoffice', channel: CacheSessionGetSource() || '', qq_redirect_url: encodeURIComponent(proxyUrl) }

      return api.user.login({ data: params }).then(res => {
        const data = res.data

        const userType = data?.user_info?.is_new_user === 0 ? 2 : 1 // 默认是新注册

        // 存储userInfo，下一步上报需要
        const userInfo = { token: data.token, ...data.user_info }
        ClientSetUserInfo(userInfo)

        // 为新注册用户，需要上报serverId
        // 上报前需要设置store的token，上报需要token值
        this.$store.commit('vuexSetUserInfo', userInfo)
        if (userType === 1) {
          reportServerId()
        }

        this.getPrivliege(userInfo, userType) // 获取用户权益
      })
    },

    getSvrid () {
      return new Promise((resolve) => {
        ClientGetDBUserInfo((res) => { // 成功失败都走查询绑定接口
          const svrId = res?.svrid // 没有svrid根据token判定是否需要绑定
          resolve(svrId)
        }, () => {
          resolve('')
        })
      })
    },

    userLoginKenqiu (code) {
      const params = { code }
      return keniuApi.qqLogin({ data: params }).then(async res => {
        const svrid = await this.getSvrid()
        const loginParams = { channel: CacheSessionGetSource(), token: res.data.data.token_info.token, svrid }
        // eslint-disable-next-line sonarjs/no-identical-functions
        api.user.loginThirdKeniu({ data: loginParams }).then((res) => {
          const isOk = res.data.user_info?.uid
          if (isOk) {
            const userInfo = { token: res.data.token, ...res.data.user_info }
            this.getPrivliege(userInfo)
          }
        })
      })
    },

    closeWxLoginTable () {
      const map = {
        [loginAppType.keniu]: TableKey.keniuPublicLogin,
        [loginAppType.wanmei]: TableKey.loginTable
      }
      ClientCloseTable(map[this.loginType])
    },

    getPrivliege (userInfo, userType) {
      let privliegeName = ''
      let privliegeEndTime = ''
      let isVip = false

      api.user.privliege({ data: { common: { token: userInfo.token, uid: userInfo.uid } } }).then(pRes => {
        privliegeName = pRes.data.name
        privliegeEndTime = pRes.data.end_date
        isVip = true
      }).catch(data => {
        if (data?.ret && data.ret.toString() in RetCode) {
          privliegeName = RetCode[data.ret]
        }
      }).finally(() => {
        const lastUserInfo = { privliegeName, privliegeEndTime, isVip, ...userInfo }

        // this.reportLogin(9, userType)

        ClientSetUserInfo(lastUserInfo)
          .then(() => {
            ClientSendMsgToTable('matDetail', 'logined')
            this.closeWxLoginTable()
            ClientCloseSelf()
          })
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.dialog_box { background-color: $bg; }
</style>
